import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Header from './components/Header/Header';
import ModalOrderHeader from './components/Header/ModalOrderHeader';
import { isAuthenticated } from './services/auth';
import 'materialize-css/dist/css/materialize.min.css';
import 'materialize-css/dist/js/materialize';
import 'material-design-icons/iconfont/material-icons.css';
import './assets/css/base.css';
import './assets/css/layout.css';
import './assets/css/loader.min.css';
import './assets/css/chat.css';
import 'typeface-roboto';
import '@mdi/font/css/materialdesignicons.css';
import Loading from './components/UI/Loading';
import { isNullOrEmpty, checkOriginNonProd } from './utils/util';
import SecurityService from './services/SecurityService';

const App = (props) => {
    let stop = false;
    useEffect(() => {
        setUserToken();
        setTheme();
        // eslint-disable-next-line
    }, [props.theme]);

    const setUserToken = () => {
        if (isAuthenticated() && isNullOrEmpty(props.user.vision)) {
            stop = true;
            props.loadUser(() => {
                stop = false
            });

            setTimeout(() => {
                if (stop) {
                    stop = false;
                    console.log("Pausa Stop Reducer User");
                }
            }, 5000);

            while (stop === true) {
                console.log("Carregando Reducer User")
            }
        }
    }

    const setTheme = () => {
        if (navigator.userAgent === 'logisticspwa') {
            import('./assets/css/scrollMobile.css').then(() => {
                console.log("scrollMobile");
            });
        } else {
            import('./assets/css/scrollWeb.css').then(() => {
                console.log("scrollWeb");
            });
        }

        const theme = localStorage.getItem("THEME");
        if (isNullOrEmpty(theme)) {
            if (checkOriginNonProd(window)) {
                import('./assets/css/themes/dark.css').then(() => {
                    console.log("Tema DARK");
                });
            } else {
                import('./assets/css/themes/white.css').then(() => {
                    console.log("Tema WHITE ");
                });
            }
        } else {
            import(`./assets/css/themes/${theme}.css`).then(() => {
                console.log(`Tema set ${theme}`);
            });
        }
    }

    return (
        <div>
            {
                isAuthenticated() && <Header />
            }
            <Loading show={props.showLoading} />
            <Loading show={props.showProcessing} text={props.textProcessing} />
            <audio id="audioLog" style={{ display: 'none' }} />
            <ModalOrderHeader />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        showLoading: state.loadingReducer.showLoading,
        showProcessing: state.loadingReducer.showProcessing,
        textProcessing: state.loadingReducer.textProcessing,
        theme: state.userReducer.theme,
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadUser: (callback) => {
            dispatch(SecurityService.loadUser(callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);